<template>
  <div class="contain_partner">
    <span>承接山东承接山东承接山东承接山东承接山东承接山东承接山东承接山东承接山东承接山东</span>

    <h5>合作案例</h5>
  </div>


</template>

<script>
    export default {
        name: "partner"
    }
</script>

<style scoped lang="scss">
  .contain_partner{
    display: flex;
    flex-direction: column;
    justify-content: center;

  }
</style>



// WEBPACK FOOTER //
// src/view/partner.vue